import React from "react";
import { Modal as ReactModal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CloseIcon } from "../utils/icon.utils";
import styled from "styled-components";
import { GroupBtn } from "./GroupBtn";

export default function Modal({
  title = "",
  modal = false,
  toggle = () => {},
  children,
  btns = [],
  ...rest
}) {
  return (
    <ModalContainer isOpen={modal} toggle={toggle} {...rest}>
      <ModalHeader
        className="justify-content-between border-0"
        close={<CloseIcon role="button" onClick={toggle} />}
        toggle={toggle}
      >
        {title ?? ""}
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      {!!btns?.length && (
        <ModalFooter className="border-0">
          <GroupBtn btns={btns} />
        </ModalFooter>
      )}
    </ModalContainer>
  );
}

const ModalContainer = styled(ReactModal)`
  font-size: 0.9rem;

  .modal-title {
    font-size: 1rem;
    font-weight: 600;
  }
`;
